<div class="root-container" #content (click)="show = true">
    <input type="text"
            placeholder="Search HPI Marketplace Products"
            maxlength="100"
            (keydown.enter)="search()"
            [formControl]="query">
    <button type="button" (click)="search()"><i class="bi bi-search"></i></button>

    @if (query.value && show) {
      <div class="suggestions scrollbars">
        @if (!loading()) {
          @for (product of productSuggestions(); track $index) {
            <div (click)="navigate(product.uuid)" class="item">
              <div class="img-container">
                <img [src]="product.image ?? 'assets/images/defaults/default_image.png'" alt="product image">
              </div>
              <div class="details">
                <h3 class="name">{{ product.name }}</h3>
                <p class="model">{{ product.model }}</p>
              </div>
            </div>
          }
          @empty {
            <div class="item" (click)="search()">
              <div class="details">
                <div class="empty">Search: <span>"{{ query.value }}"</span></div>
              </div>
            </div>
          }
        }
      </div>
    }
</div>
